'use strict';

import { view } from '@/functions';

const prefix = '/audit-logs';

// The audit database is only wired in production
export default import.meta.env.PROD ? [
    {
        path: prefix,
        name: 'audit-logs',
        meta: {
            title: 'Audit logs',
            scopes: ['read_audit_logs']
        },
        component: () => view('audit-logs/index')
    },
] : [];
